<template>
  <article></article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import UtilsService from '../../services/utils.service';

export default defineComponent({
  name: 'otb-widget-loader',
  props: {
    resources: {
      type: Object,
    },
    insideShadow: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const promiseArray: Promise<HTMLScriptElement | HTMLLinkElement>[] = [];
    if (props.resources) {
      // eslint-disable-next-line max-len
      props.resources.forEach(
        (resource: any) =>
          resource &&
          promiseArray.push(
            UtilsService.fetchResource(resource, props.insideShadow)
          )
      );
      Promise.all(promiseArray)
        .then(() => {
          emit('resources-loaded');
        })
        .catch((error) => {
          emit('error-resources-loaded', error);
        });
    } else {
      throw new Error('Invalid DLC configuration');
    }
  },
});
</script>
